import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  AlertController,
  NavParams,
  SelectPopover,
} from "ionic-angular";
import { ModalsUserseditPage} from "../modals-usersedit/modals-usersedit";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { RestProvider } from "../../providers/rest/rest";
import { DataProvider } from "../../providers/data/data";
import { ViewerPage } from "../viewer/viewer";
import * as fs from 'fs';
import * as Axios from "axios";
import { FileWriter } from "@ionic-native/file";
import { ModalsEngineselectorPageModule } from "../modals-engineselector/modals-engineselector.module";
import { FORGECLIENT } from '../../environments/environment';


@IonicPage()
@Component({
  selector: "page-users",
  templateUrl: "users.html",
  encapsulation: ViewEncapsulation.None
})
export class UsersPage {
  @ViewChild("fileInput") fileInput;
  usersForm = new FormGroup({
    usersControl: new FormControl(),
  });
  reader = new FileReader();
  userList = [];
  columns = [
    { name: 'ユーザーＩＤ', prop: 'id' },
    { name: 'ユーザー名', prop: 'name' },
    { name: 'ログイン名', prop: 'username' },
    { name: 'ログインパスワード', prop: 'password' },
    { name: '所属名称', prop: 'organization' },
    { name: '役割', prop: 'role' },
    { name: 'フォルダ名', prop: 'bucket_name' },
    { name: '編集', sortable: false, prop: '' }
  ];

  loading;
  nickname = FORGECLIENT.CLIENT_ID;
  appboundle_name = 'UpdateRVTParam';
  zip_name = 'UpdateRVTParam.zip';
  alias = '23';
  findApp = false;
  page = 1;
  bucketArray = [];



  activeengine: number;
  status: boolean = false;
  enginename = localStorage.getItem('engine') == null ? 'Autodesk.Revit+2020' : localStorage.getItem('engine');

  public rows : any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalController: ModalController,
    public AlertController: AlertController,
    private rest: RestProvider
  ) {}

  ionViewDidLoad() {
    this.getUsers();
  }

  onSort(event) {
    setTimeout(() => {
      const rows = [...this.rows];
      const sort = event.sorts[event.sorts.length - 1];
      if(sort !== undefined) {
        rows.sort((a, b) => {
          if(event.column.prop == 'id') {
            if(sort.dir === 'desc') {
              return parseInt(b[event.column.prop]) - parseInt(a[event.column.prop]);
            } else {
              return parseInt(a[event.column.prop]) - parseInt(b[event.column.prop]);
            }
          } else {
            return a[event.column.prop].localeCompare(b[event.column.prop]) * (sort.dir === 'desc' ? -1 : 1);
          }
        });
      }
      this.rows = rows;
    }, 1000);
  }

  sort(event, dir, sort) {
    console.log(event);
    console.log(dir);
    console.log(sort);
  }

  getUsers() {
    setTimeout(function(){ console.log('wait here 3 sec'); }, 1500);
    this.presentLoadingWithOptions();
    this.userList = [];
    this.rest.users().subscribe( response => {
      console.log('users -> ',response);
      if(response.result == 'ok') {
        for(let i = 0; i < response.data.length; i++){
          if(response.data[i].role == 4) {
            console.log('role 4 tei tentsuu baina.');
            response.data.splice(i, 1);
            i++;
          }
        }
        this.userList = response.data;
        this.rows = this.userList;
        for( let i = 0; i < response.data.length; i++ ) {
          if(response.data[i].bucket_id != null){
            response.data[i].bucket_name = '';
            if(response.data[i].bucket_id.includes(',')) {
              let bucketIdarray = response.data[i].bucket_id.split(',');
              console.log('bucketIdArray', bucketIdarray);
              
              for(let j = 0; j < bucketIdarray.length; j++) {
                if(bucketIdarray[j] != null) {
                  this.rest.getBucketName(bucketIdarray[j]).subscribe(responseSingleBucketName => {
                    if(responseSingleBucketName.data.length != 0){
                      console.log('rest response => ',responseSingleBucketName.data[0].bucket_name);
                      response.data[i].bucket_name += (response.data[i].bucket_name == '' ? '' : ', ') + responseSingleBucketName.data[0].bucket_name;
                      console.log("response => data => i", response.data[i]);
                    }
                  });
                }
              }
            } else {
              this.rest.getBucketName(response.data[i].bucket_id).subscribe(responseSingleBucketName => {
                if(responseSingleBucketName.data.length != 0){
                  console.log('rest response => ',responseSingleBucketName.data[0].bucket_name);
                  response.data[i].bucket_name += (response.data[i].bucket_name == '' ? '' : ', ') + responseSingleBucketName.data[0].bucket_name;
                  console.log("response => data => i", response.data[i]);
                }
              });
            }
          }
        }
        this.stopLoading();
      }
    });
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    console.log('loader ---->>>>');
    return await this.loading.present();
  }
  
  async stopLoading() {
    console.log('loader <<<<----');
    return await this.loading.dismiss();
  }
  async presentAlertConfirm(bundle) {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p><strong>バケット</strong>を削除してもよろしいですか</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('cancelled');
          }
        }, {
          text: 'はい',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertEngineError() {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'エラー!',
      message: '<p><strong>エンジン</strong>を選択</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertBundleError() {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'エラー!',
      message: '<p>間違った<strong>バンドル</strong></p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertEngine(values) {

    
    this.rest.buckets().subscribe( response => {
      console.log(response);
      if(response.result == 'ok') {
        this.rest.getBuckets().subscribe( buckets => {
          console.log('bucket list => ',buckets);
          this.bucketArray = [];
          for(let i = 0; i < buckets.items.length; i++) {
            for(let j = 0; j < response.data.length; j++) {
              if(response.data[j].bucket_id == buckets.items[i].bucketKey) {
                this.bucketArray.push(response.data[j]);
              }
            }
          }
          console.log('bucketArray => ', this.bucketArray);
          let request_sent = this.modalController.create(
            ModalsUserseditPage,
            { data: values, buckets: this.bucketArray },
            {
              showBackdrop: true,
              enableBackdropDismiss: true,
            }
          );
      
          request_sent.present().catch(err => {
      
          });
      
          request_sent.onDidDismiss((data) => {
            console.log('dismiss darlaa', data);
            this.getUsers();
          });
          
        });
      }
    });
  }
  async presentAlertBuckets(values) {
    
    this.rest.buckets().subscribe( response => {
      if(response.result == 'ok') {
        

          let request_sent = this.modalController.create(
            ModalsUserseditPage,
            { data: values, buckets: this.bucketArray },
            {
              showBackdrop: true,
              enableBackdropDismiss: true,
            }
          );
      
          request_sent.present().catch(err => {
      
          });
      
          request_sent.onDidDismiss((data) => {
            console.log('dismiss darlaa', data);
            this.getUsers();
          });
      }
    });
  }
  async presentAlertDeleteUser(id) {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p><strong>Delete</strong> user</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('cancelled');
          }
        }, {
          text: 'はい',
          handler: () => {
            this.deleteUser(id);
          }
        }
      ]
    });

    await alert.present();
  }

  deleteUser(id) {
    this.rest.updateuser(id,null,null,null,null,null,null,'delete').subscribe( response => {
      this.getUsers();
    });
  }
}

$('.datatable-header-cell-template-wrap').on('click', function(event) {
  console.log("uduugduj bna xD", event);
});


// WEBPACK FOOTER //
// ./src/pages/users/users.ts